import {mapActions, mapMutations, mapGetters} from "vuex";

export default {
    name: "card",
    components: {},
    props: {
        item: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {
            payload: {}
        }
    },
    created() {
    },
    computed: {
        ...mapGetters({})
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({}),

    }
}
